export default __webpack_public_path__ + "static/media/solicitors.9dc99abf.webp";